import { makeStyles } from "tss-react/mui";
const useStyles = makeStyles()((theme)=>({
        preloader: {
            position: 'absolute',
            top: theme.px(28),
            right: theme.tokens.spacing['16']
        }
    }));
const Preloader_style = useStyles;
export default Preloader_style;
